/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown> }} Today_LoadInputs */

const en_us2_today_load = /** @type {(inputs: Today_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText}`)
};

const pt_br2_today_load = /** @type {(inputs: Today_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText}`)
};

const es_419_today_load = /** @type {(inputs: Today_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText}`)
};

const pt_pt2_today_load = /** @type {(inputs: Today_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText}`)
};

const fr_fr2_today_load = /** @type {(inputs: Today_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText}`)
};

const de_de2_today_load = /** @type {(inputs: Today_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText}`)
};

const it_it2_today_load = /** @type {(inputs: Today_LoadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText}`)
};

/**
* | output |
* | --- |
* | "{loadText}" |
*
* @param {Today_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_load = /** @type {((inputs: Today_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_load(inputs)
	if (locale === "es-419") return es_419_today_load(inputs)
	if (locale === "pt-PT") return pt_pt2_today_load(inputs)
	if (locale === "fr-FR") return fr_fr2_today_load(inputs)
	if (locale === "de-DE") return de_de2_today_load(inputs)
	if (locale === "it-IT") return it_it2_today_load(inputs)
	return en_us2_today_load(inputs)
});
export { today_load as "today.load" }